import { Box } from "@chakra-ui/react";
import { BoxData } from "@components";

const ProfileAttr = ({ FieldName, data }) => {
    return(
      <Box fontSize="1rem">
        <Box as="span" fontWeight="300" textColor="gray.borders">
          {FieldName}
        </Box>
        <BoxData data={data} />
      </Box>
    )
};

export default ProfileAttr;